import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@/b2b/context/ThemeContext";

/**
 * @param placeholder Optional override. Without it the placeholder is derived from `label`,
 *   which is fine for fields whose label is customer-facing — but some labels are internal
 *   shorthand ("Alt Phone"), which then leaks onto the screen as "Enter Your Alt Phone".
 *   Every existing caller omits this and keeps the previous behaviour exactly.
 */
export default function TelField({
  name,
  label,
  value,
  onChange,
  required,
  placeholder,
}) {
  const theme = useTheme();
  const isFilled = value && value !== "";

  return (
    <div
      className={`flex items-center border ${
        theme?.backgroundColor || "bg-input-bg"
      }  border-primary-300 p-2 ${
        theme?.textColor || "text-primary-100"
      } h-14 focus-within:border-primary-500 rounded-none`}
    >
      <span className="font-sans px-2  text-base">+91</span>
      <div className="border-l border-primary-200 h-6 mx-2"></div>
      <input
        data-clarity-unmask="false"
        type="tel"
        name={name}
        inputMode="numeric"
        placeholder={placeholder || `Enter Your ${label}`}
        className={` text-base 
          ${theme?.backgroundColor || "bg-input-bg"} 
          ${theme?.textColor || "text-black"} 
          focus:outline-none w-full h-full 
          placeholder-text-gray-500 peer rounded-none 
          ${
            isFilled ? (theme?.textColor ? theme?.textColor : "text-white") : ""
          } 
          ${name === "pan" ? "uppercase" : ""}`}
        maxLength={10}
        pattern="[789]\d{9}"
        value={value}
        required={required}
        onChange={(e) => {
          let val = e.target.value;
          val = val.replace(/[^\d]/g, "").slice(0, 10);
          // Remove any non-numeric characters and limit to 10 digits
          onChange(val);
        }}
      />
    </div>
  );
}

TelField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
};
